var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 170,
    viewBox: "0 0 153 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.931 127L86.5972 145.45C83.0677 148.771 78.2033 150.152 72.8412 150.152C67.4791 150.152 62.6203 148.771 59.0852 145.45L26.4147 114.574C22.9078 111.254 21.1148 106.409 21.1148 101.372C21.1148 96.3149 22.9078 91.7462 26.4147 88.4524L58.9947 57.4062C62.5016 54.1177 67.4791 52.8427 72.8412 52.8427C78.2033 52.8427 83.0677 54.224 86.5972 57.5443L106.931 75.9946C110.817 79.6496 117.243 79.5168 121.276 75.7184C125.28 71.9305 125.433 65.9009 121.542 62.2459L101.897 43.5937C96.8088 38.8795 90.4211 35.5918 83.4523 34.1002L102.044 16.3937C105.936 12.744 105.817 6.70898 101.779 2.92117C97.74 -0.86664 91.3202 -0.983515 87.4343 2.64492L11.2503 74.199C3.85756 81.169 0 90.7368 0 101.362C0 111.966 3.86322 121.868 11.2503 128.817L44.0396 159.693C51.4323 166.636 61.6588 169.983 72.9713 169.983C84.2555 169.983 94.4707 166.355 101.869 159.417L121.547 140.711C125.439 137.083 125.286 131.059 121.253 127.266C117.22 123.472 110.795 123.334 106.937 126.989L106.931 127ZM142.453 92.1605H65.9179C60.6463 92.1605 56.3476 96.4159 56.3476 101.675C56.3476 106.94 60.6463 111.222 65.9179 111.222H142.453C147.73 111.222 152.029 106.935 152.029 101.675C152.029 96.4212 147.73 92.1605 142.453 92.1605Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon3);
export default __webpack_public_path__ + "static/media/nav-icon3.3e53b0587b63434ff4361ee01c9bd7b0.svg";
export { ForwardRef as ReactComponent };